import { connect } from "react-redux";
import { RouteProps } from "react-router";

import PrivateRoute, { IPrivateRouteProps } from "./private-route";

export default connect(
  (state: { user }, own: RouteProps): IPrivateRouteProps => {
    const { user } = state;
    const { component, ...rest } = own;
    return {
      ...rest,
      component,
      isAuthenticated: !!user.userId
    };
  }
)(PrivateRoute);
